import React from 'react';
import Card from '@common/components/card';

export interface SettingsCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  description,
  children,
  actions,
  className = '',
}) => {
  return (
    <Card containerClassName={className}>
      <Card.Content className="!tw-p-5">
        <div className="tw-flex tw-flex-row">
          <div className="tw-w-1/2 tw-flex tw-flex-col tw-gap-[6px]">
            <div className="tw-text-xl tw-text-inter tw-font-semibold tw-text-gray-textDark">
              {title}
            </div>
            {description && (
              <div className="tw-text-gray-muted tw-text-base tw-font-medium tw-text-inter">
                {description}
              </div>
            )}
          </div>
          <div className="tw-w-1/2 tw-flex tw-flex-col tw-gap-2">
            {children}
            {actions && (
              <div className="tw-flex tw-flex-row tw-gap-2 tw-mt-4">
                {actions}
              </div>
            )}
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};
